import { webEvent } from "./event";

export const mobileInfoShown = () => webEvent("mobile_info", "shown");
